<template>
  <VForms
    v-if="open"
    :initial-values="initialValues"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form @submit.prevent="props.handleSubmit">
        <v-container grid-list-md>
          <PetsFormFields
            :form="props"
            @getRaces="getRaces"
          />
          <v-layout
            row
            justify-end
          >
            <v-flex
              xs12
              md5
              text-md-right
            >
              <v-btn
                color="primary"
                outline
                @click="$emit('close')"
              >
                {{ $t('button.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                :loading="props.isSubmitting"
                type="submit"
              >
                {{ submitButtonLabel }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </template>
  </VForms>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { Form as VForms } from '@v-forms/core'
import {
  required,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators'
import {
  ACTION_GET_SPECIES,
  ACTION_GET_RACES,
  ACTION_CREATE_PET,
  ACTION_UPDATE_PET,
} from '../../store/types/pets.types'
import PetsFormFields from './PetsFormFields'

export default {
  name: 'PetsForm',
  components: {
    VForms,
    PetsFormFields,
  },
  props: {
    type: {
      type: String,
      default: 'new',
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validations: {
        name: { required },
        species: { required },
        race: { required },
        sex: { required },
        birthDate: { required },
        weight: { required },
        microchip: {
          minLength: minLength(15),
          maxLength: maxLength(15),
        },
      },
    }
  },
  computed: {
    submitButtonLabel() {
      return this.type === 'new' ? this.$t('button.add') : this.$t('button.save')
    },
  },
  watch: {
    open() {
      if (this.type === 'edit') this.getRaces(this.initialValues.species)
    },
  },
  mounted() {
    this.getSpecies()
  },
  methods: {
    handleSubmit(values, actions) {
      const pet = Object.assign(values, { birthDate: moment(values.birthDate).toISOString() })
      if (this.type === 'new') this.createPet(pet)
      else this.updatePet(pet)
      actions.setSubmitting(false)
      this.$emit('close')
    },
    ...mapActions({
      getSpecies: ACTION_GET_SPECIES,
      getRaces: ACTION_GET_RACES,
      createPet: ACTION_CREATE_PET,
      updatePet: ACTION_UPDATE_PET,
    }),
  },
}
</script>

<style>

</style>
